import React from "react";

import { StyledButtonsBlock } from "./styled";

const ButtonsBlock = ({ children, styles }) => (
  <StyledButtonsBlock styles={styles}>{children}</StyledButtonsBlock>
);

export default ButtonsBlock;
